<tec-modal
	[isVisible]="(pickerUi.isOpen$ | async) === true"
	[title]="'GENERAL.LANGUAGE_PICKER.TITLE' | translate"
	(closeEvent)="closeModal()"
>
	<div class="modal__body modal-change-language__body grid">
		@if (hasLanguageOptions) {
			<p class="modal-change-language__intro">
				{{ 'GENERAL.LANGUAGE_PICKER.DESCRIPTION' | translate }}
			</p>
			<ng-container [formGroup]="languageForm">
				<tec-select [options]="languageSelectOptions" formControlName="locale"></tec-select>
			</ng-container>
		} @else {
			<tec-alert
				[msg]="'GENERAL.LANGUAGE_PICKER.MASTER_LOAD_ERROR' | translate"
				type="message"
				status="warning"
				icon="icon-alert"
				hiddenCloseButton
			/>
		}
	</div>
</tec-modal>
